import { Trans, useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router";
import { useDispatch } from "src/store";

import { closeDetails, setPaneTab } from "@devices/store";
import { Group } from "@devices/types";
import { Box } from "@mui/material";
import { getSettings } from "@services/configService";
import { CustomAlert } from "@shared/CustomAlert/CustomAlert";
import { TextLink } from "@shared/TextLink";

export const EmptyGroupHint = (props: Group) => {
    const { t } = useTranslation(["sidepanels"]);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const location = useLocation();
    const { features } = getSettings();

    // Counted with subgroups: a group that only holds other groups has been set up already.
    const isUntouched = (props.statistics?.aggregated.deviceCount ?? 0) === 0 && !props.policyId;
    if (!isUntouched) {
        return null;
    }

    const showDevicesPage = () => {
        if (location.pathname === "/dashboard/devices") {
            dispatch(closeDetails());
        } else {
            void navigate("/dashboard/devices");
        }
    };

    // Not named "link": i18next parses <link> as a void element and would leave the label outside the anchor.
    const components = {
        enrollmentTabLink: (
            <TextLink
                component="button"
                type="button"
                onClick={() => dispatch(setPaneTab("ENROLLMENT"))}
                tooltip={t("sidepanels:groupPanel.tooltip.openEnrollmentTab")}
            />
        ),
        devicesPageLink: (
            <TextLink
                component="button"
                type="button"
                onClick={showDevicesPage}
                tooltip={t("sidepanels:groupPanel.tooltip.goToDevicesPage")}
            />
        ),
        policyTabLink: (
            <TextLink
                component="button"
                type="button"
                onClick={() => dispatch(setPaneTab("POLICY"))}
                tooltip={t("sidepanels:groupPanel.tooltip.openPolicyTab")}
            />
        ),
    };

    return (
        <Box sx={{ marginBottom: 3 }}>
            <CustomAlert severity="info">
                <Trans
                    t={t}
                    i18nKey={
                        features.groupPanel.enrollmentTabEnabled
                            ? "sidepanels:groupPanel.overviewTab.emptyGroupHint.addDevices"
                            : "sidepanels:groupPanel.overviewTab.emptyGroupHint.moveDevices"
                    }
                    components={components}
                />
                {features.pages.policiesPageEnabled ? (
                    <>
                        {" "}
                        <Trans
                            t={t}
                            i18nKey="sidepanels:groupPanel.overviewTab.emptyGroupHint.assignPolicy"
                            components={components}
                        />
                    </>
                ) : null}
            </CustomAlert>
        </Box>
    );
};
